/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Stock_ValueInputs */

const vi_report_inventory_stock_value = /** @type {(inputs: Report_Inventory_Stock_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá trị tồn kho`)
};

/**

* @param {Report_Inventory_Stock_ValueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_stock_value = /** @type {((inputs?: Report_Inventory_Stock_ValueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Stock_ValueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_stock_value(inputs)
});